import React, { Component } from 'react';
import { reduxForm } from 'redux-form';
import { browserHistory, Link } from 'react-router';
import withNotify from '../../common/withNotify';
import withLoader from '../../common/withLoader';
import withGoBack from '../../common/withGoBack';
import Header from '../../components/Header';
import withTeam from '../../common/withTeam';
import withOnline from '../../common/withOnline';
import withCaseFilter from '../../common/withCaseFilter';
import withCalendarFilter from '../../common/withCalendarFilter';
import withSearchFilter from '../../common/withSearchFilter';
import withUpdatedRoute from '../../common/withUpdatedRoute';
import withViewDersDetails from '../../common/withViewDersDetails';
import { getBillingCounts } from '../../utils/utils';
import Bugsnag from '../../helpers/bugsnag';
import { storeLastVisitedRoute } from '../../common/globals';

class BillingHome extends Component {
  constructor(props) {
    super(props);
    this.state = {
      countData: [],
    };
  }

  componentDidMount() {
    try {
      const { setGoBack } = this.props;
      setGoBack([]);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onGoBack = () => {
    try {
      const { goBack, setGoBack } = this.props;
      goBack.push(window.location.pathname);
      setGoBack(goBack);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onRedirect = (path) => {
    try {
      this._onGoBack();
      browserHistory.push(path);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _getBillingCounts = () => {
    try {
      const { notify, online, setLoader } = this.props;
      setLoader(true);
      if (online) {
        getBillingCounts().then((responseJson) => {
          const { status, message, data } = responseJson;
          if (status) {
            this.setState({ countData: data });
            setLoader(false);
          } else {
            notify({ type: 'error', message });
            setLoader(false);
          }
        });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _onMissingDgrs = () => {
    try {
      const {
        online, notify, setCaseFilter, setCalendarFilter, setSearchFilter
      } = this.props;
      if (online) {
        setCaseFilter({});
        setCalendarFilter({});
        setSearchFilter({});
        this._onRedirect('/missing-dgr');
      } else {
        notify({ type: 'error', message: 'You must have an internet connection to view billing details.', time: 3 });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onMissingPos = () => {
    try {
      const {
        online, notify, setCaseFilter, setCalendarFilter, setSearchFilter
      } = this.props;
      if (online) {
        setCaseFilter({});
        setCalendarFilter({});
        setSearchFilter({});
        this._onRedirect('/missing-pos');
      } else {
        notify({ type: 'error', message: 'You must have an internet connection to view billing details.', time: 3 });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onNotBilled = () => {
    try {
      const {
        online, notify, setCaseFilter, setCalendarFilter, setSearchFilter
      } = this.props;
      if (online) {
        setCaseFilter({});
        setCalendarFilter({});
        setSearchFilter({});
        this._onRedirect('/billing/notBilledCases');
      } else {
        notify({ type: 'error', message: 'You must have an internet connection to view billing details.', time: 3 });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onBilled = () => {
    try {
      const {
        online, notify, setCaseFilter, setCalendarFilter, setSearchFilter
      } = this.props;
      if (online) {
        setCaseFilter({});
        setCalendarFilter({});
        setSearchFilter({});
        this._onRedirect('/search-billed');
      } else {
        notify({ type: 'error', message: 'You must have an internet connection to view billing details.', time: 3 });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  async UNSAFE_componentWillMount() {
    try {
      const {
        online, notify, setUpdatedRoute, setViewDersDetails
      } = this.props;
      if (online) {
        await this._getBillingCounts();
      } else {
        notify({ type: 'error', message: 'You must have an internet connection to view billing details.', time: 3 });
      }
      storeLastVisitedRoute('/billing');
      setUpdatedRoute('/billing');
      setViewDersDetails(false);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  render() {
    const { team: { salesAccess } } = this.props;
    const { countData } = this.state;
    return (
      <section>
        <Header
          sideMenu
          goBack="/"
        />
        <div className="container mt-4">
          <div className="row g-4">
            <div className="col-12">
              <Link className="btn btn-theme-alt btn-theme-outline-alt d-block btn-max-width" onClick={this._onMissingDgrs}>
                Missing DGRs <span className="badge">{countData.missingDGRCaseCount !== undefined ? countData.missingDGRCaseCount : 0}</span>
              </Link>
            </div>
            <div className="col-12">
              <Link className="btn btn-theme-alt btn-theme-outline-alt d-block btn-max-width" onClick={this._onMissingPos}>
                Missing POs
              </Link>
            </div>
            <div className="col-12">
              <Link className="btn btn-theme-alt btn-theme-outline-alt d-block btn-max-width" onClick={this._onNotBilled}>
                Not Billed
              </Link>
            </div>
            {
              (salesAccess)
              && (
                <div className="col-12">
                  <Link onClick={this._onBilled} className="btn btn-theme-alt btn-theme-outline-alt d-block btn-max-width">Billed</Link>
                </div>
              )
            }
          </div>
        </div>
      </section>
    );
  }
}

const withForm = reduxForm({
  form: 'BillingHomeForm',
});

export default withSearchFilter(
  withCaseFilter(
    withCalendarFilter(
      withOnline(
        withTeam(
          withForm(
            withGoBack(
              withNotify(
                withLoader(
                  withUpdatedRoute(
                    withViewDersDetails(
                      BillingHome
                    )
                  )
                )
              )
            )
          )
        )
      )
    )
  )
);
